import axios from 'axios'
import querystring from 'querystring'

const auth_key = 'd54dff00-4228-c230-19fe-cf1f680d9c3b'

async function translateApi(parameters) {
    return axios.post('https://api.deepl.com/v2/translate', querystring.stringify(parameters))
}
async function usage() {
    return axios.post('https://api.deepl.com/v2/usage', querystring.stringify({ auth_key }))
}

const useTranslation = () => {
    const translate = (params) =>
        translateApi({ auth_key, ...params }).then((result) => {
            return {
                ...result,
                data: { ...result.data, translations: result.data.translations.map((tr) => ({ ...tr, text: tr.text.replace(/\n/g, '') })) },
            }
        })
    return { translate, usage }
}

export default useTranslation
